import { tv, type VariantProps } from "tailwind-variants";

export const carouselNavVariants = tv({
  slots: {
    base: [
      "w-full relative z-10 grid grid-cols-1 gap-6 md:grid-cols-2",
      "justify-end",
      "-mt-14 lg:-mt-20",
      "lg:z-1",
    ],
    sliderNav: ["flex gap-4 lg:gap-2 px-8 lg:px-12", "ml-auto rtl:mr-auto"],
    button: [
      "flex items-center justify-center",
      "p-3",
      "border border-border-static-white lg:border-border-neutral-default",
      "rounded-lg",
      "transition-colors duration-300 ease-in-out hover:bg-neutral-dark-alpha/5",
      "disabled:opacity-50 disabled:cursor-not-allowed",
    ],
    icon: [
      "w-4 h-4",
      "ease-in-out duration-300",
      "text-text-static-white-soft lg:text-text-neutral-softer",
    ],
  },
});

export type CarouselNavVariantProps = VariantProps<typeof carouselNavVariants>;

export type CarouselNavReturnVariantProps = ReturnType<typeof carouselNavVariants>;
